module.exports = __webpack_public_path__ + "static/media/background-blue-rain.fb9e2f6c.jpg";